import React from 'react';

const CHUNK_RELOAD_KEY = 'auditVaultChunkReload';
const RELOAD_GUARD_MS = 30000;

function isChunkLoadError(error) {
    const errorText = `${error?.name || ''} ${error?.message || ''}`;

    return /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module/i.test(errorText);
}

export default class ChunkLoadErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { chunkLoadFailed: false };
    }

    static getDerivedStateFromError(error) {
        if (isChunkLoadError(error)) {
            return { chunkLoadFailed: true };
        }

        throw error;
    }

    componentDidCatch(error) {
        if (!isChunkLoadError(error)) {
            return;
        }

        const lastReload = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
        const now = Date.now();

        if (!lastReload || now - lastReload > RELOAD_GUARD_MS) {
            window.sessionStorage.setItem(CHUNK_RELOAD_KEY, now.toString());
            window.location.reload();
        }
    }

    handleRetry = () => {
        window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        window.location.reload();
    };

    render() {
        if (!this.state.chunkLoadFailed) {
            return this.props.children;
        }

        return (
            <main
                role="alert"
                style={{
                    maxWidth: 640,
                    margin: '64px auto',
                    padding: 24,
                    fontFamily: 'Roboto, Arial, sans-serif',
                    textAlign: 'center',
                }}
            >
                <h1 style={{ fontSize: '1.5rem' }}>The application was updated</h1>
                <p>A required page file could not be loaded. Refresh the application to continue.</p>
                <button
                    type="button"
                    onClick={this.handleRetry}
                    style={{
                        border: 0,
                        borderRadius: 4,
                        padding: '10px 20px',
                        background: '#1976d2',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '1rem',
                    }}
                >
                    Refresh application
                </button>
            </main>
        );
    }
}
